var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.items, function (item, name) {
      return _c(
        item.component,
        _vm._b(
          {
            key: name,
            tag: "component",
            attrs: { name: name, filters: _vm.filters },
            on: {
              "filter-change": _vm.filterChange,
              "labels-change": _vm.labelsChange,
            },
          },
          "component",
          item,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }